import React, { useState } from 'react';

import { ReactComponent as EyeOpenSvg } from './imgs/eye-open.svg';
import { ReactComponent as EyeCloseSvg } from './imgs/eye-close.svg';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss')
} else {
    require('./style.scss')
}

type type = 'password' | 'text';
export interface IInput {
    defaultValue?: string,
    inputId?: string,
    onChange: (value:string) => any,
    onBur?: (value: string) => any,
    placeholder?: string
    register?: object,
    errorText?: string,
    type?: type,
    extraClass?: string,
    maxLength?: number,
    id?: string,
}

const Input: React.FC<IInput> = ({inputId, defaultValue, type = 'text', onChange, onBur, placeholder, errorText, maxLength, extraClass, id}) => {
    const [focused, setFocused] = useState<boolean>(false);
    const [value, setValue] = useState<string>(defaultValue || '');
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleOnBur = (value: string) => {
        onBur && onBur(value);
        setFocused(false);
    }
    const handleInputChange = (iptValue: string) => {
        setValue(iptValue);
        onChange && onChange(iptValue)
    }

    const renderEyeBtn = () => {
        return (
            showPassword ? 
            <EyeOpenSvg className="password-input-eye-btn" onClick={() => setShowPassword(false)} /> : 
            <EyeCloseSvg className="password-input-eye-btn" onClick={() => setShowPassword(true)} />
        )
    }

    return (
        <div id={id} className={`input-wrapper ${focused ? 'input-focus' : ''} ${errorText ? 'input-error' : ''} ${extraClass ? extraClass : ''}`}>
            <input
                id={inputId}
                type={showPassword ? 'text' : type}
                value={value}
                onChange={(evt) => handleInputChange(evt?.target?.value)}
                autoComplete="new-password"
                onFocus={() => setFocused(true)}
                onBlur={(evt) => handleOnBur(evt?.target?.value)}
                placeholder={placeholder || ''}
                className={`${type === 'password' ? 'password-input-text' : ''}`}
                maxLength={maxLength}
            />
            { type === 'password' ? renderEyeBtn() : null }
            { errorText ? <p className="error-tip">{errorText}</p> : null}
        </div>
    )
}

export default Input;
